import request from '@/utils/request'
// import requestTest from '@/utils/requestTest'
import { getBrowserInfo } from '@/utils/index'

// 登录
export function login(data) {
  return request({
    url: '/health-uaa/uaa/login/password',
    method: 'post',
    headers: { _c: 5, _m: getBrowserInfo() },
    data
  })
}

// 随访系统登录
export function followUpLogin(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/hospital/clearCacheAndLogin',
    method: 'post',
    data
  })
}

// 登出
export function logout(data) {
  return request({
    url: '/health-uaa/uaa/login/logout',
    method: 'post',
    headers: {
      _c: 5,
      _m: getBrowserInfo(),
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: data
  })
}

// 获取当前健管今天第几次切换休息的接口
export function getRestCount() {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/getScheduledRestCount',
    method: 'get'
  })
}

// 切换坐班状态
export function statusUpdate(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/update-shift-status',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: data
  })
}

// 获取个人信息
export function UserInfo(data) {
  return request({
    url: '/health-user/doctor-assistant/select-da-user-info',
    method: 'get',
    params: data
  })
}

//获取管理员列表
export function getPermission() {
  return request({
    url: '/health-doctor-assistant/workOrder/permission',
    method: 'get'
  })
}

//获取版本
export function getVersion() {
  return request({
    url: '/health-uaa/version',
    method: 'get'
  })
}
// 获取工单字典Map
export function getWorkOrderDict() {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/work-order/workOrderBusinessTypeDict',
    method: 'get'
  })
}
// 获取工单字典List
export function apiWorkOrderDictList() {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/work-order/workOrderBusinessTypeDictList',
    method: 'get'
  })
}
// 获取腾讯云呼叫中心SDK URL
export function getTcccURL() {
  return request({
    url: '/health-doctor-assistant/tccc/create/sdk/login/token',
    method: 'post'
  })
}

// 获取腾讯云呼叫中心获取 技能组ID
export function getSkillGroupId(data) {
  return request({
    url: '/health-doctor-assistant/tccc/record-save-before-call',
    method: 'post',
    data
  })
}

// 外呼前：通过手机号识别被叫（识别成功才允许拨打）
export function identifyCalleeByPhone(data) {
  return request({
    url: '/health-doctor-assistant/tccc/identify-callee-by-phone',
    method: 'post',
    data
  })
}

// 获取呼叫人对应工单
export function getTcccWorkOrderList(params) {
  return request({
    url: '/health-doctor-assistant/tccc/get-work-order-list',
    method: 'get',
    params
  })
}

// 获取呼叫人对应信息
export function getCallerInfo(params) {
  return request({
    url: '/health-doctor-assistant/tccc/get-caller-info',
    method: 'get',
    params
  })
}

// 获取呼叫人对应信息
export function getQueryUser(params) {
  return request({
    url: '/health-doctor-assistant/tccc/query-user',
    method: 'get',
    params
  })
}

// 已处理通话记录
export function processed(params) {
  return request({
    url: '/health-doctor-assistant/tccc/processed',
    method: 'get',
    params
  })
}

// 已处理通话记录
export function getCdrList(params) {
  return request({
    url: '/health-doctor-assistant/tccc/get-cdr-list',
    method: 'get',
    params
  })
}
export function getCdrPelList(params) {
  return request({
    url: '/health-doctor-assistant/tccc/get-cdr-pel-list',
    method: 'get',
    params
  })
}

// 判断是否绑定虚拟坐席
export function isRegisterPhone(params) {
  return request({
    url: '/health-doctor-assistant/tccc/register-or-not',
    method: 'get',
    params
  })
}
// 获取虚拟电话未读数总量
export function getCallunProCount() {
  return request({
    url: '/health-doctor-assistant/tccc/un-processed-count',
    method: 'get'
  })
}

// 查询坐班详情和相关的一些配置（自动拒收数，自动休息）
export function queryShiftDetail() {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/queryShiftDetail',
    method: 'get'
  })
}

// 自动更新坐班状态
// /health-doctor-assistant/doctor-assistant/update-shift-status
export function autoUpdateShiftStatus(data) {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/autoUpdateShiftStatus',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: data
  })
}
// 获取配置项
export function getMessageRecallSettings() {
  return request({
    url: '/health-im/im/messages/getMessageRecallSettings',
    method: 'get'
  })
}
// 获取随访系统超管账号密码
export function getAdminUser(params) {
  return request({
    url: '/health-third-party/followup/by-org',
    method: 'get',
    params
  })
}
// 获取职能组ID
export function getSkillGroup(params) {
  return request({
    url: '/health-message/tccc/seat/get-complaint-and-service-skill-group',
    method: 'get',
    params
  })
}
// 获取职能组ID
export function getLastService(params) {
  return request({
    url: '/health-message/cdr/get-last-service-cdr',
    method: 'post',
    data: params
  })
}
// 转线存储诉求-查询接口
export function getCallIntent(params) {
  return request({
    url: '/health-message/cdr/getCallIntent',
    method: 'get',
    params: params
  })
}
// 转线存储诉求-查询接口
export function buildCallIntent(params) {
  return request({
    url: '/health-message/cdr/buildCallIntent',
    method: 'post',
    data: params
  })
}

export function transferCallSwitch() {
  return request({
    url: '/health-doctor-assistant/tccc/transferCallSwitch',
    method: 'get'
  })
}
export function getQueryLastTreatmentPlanForAdvanceConsultationSummary(params) {
  return request({
    url: '/health-recommend/advanceConsultationSummary/queryLastTreatmentPlanForAdvanceConsultationSummary',
    method: 'get',
    params: params
  })
}

export function patientInfo(params) {
  return request({
    url: '/health-emr/emr/case/patientInfo',
    method: 'get',
    params: params
  })
}
// 坐席列表
export function setSeatList(params) {
  return request({
    url: '/health-message/tccc/seat/seat-list',
    method: 'post',
    data: params
  })
}
export function getLatestThreeService(params) {
  return request({
    url: '/health-message/cdr/get-latest-three-service-cdr',
    method: 'post',
    data: params
  })
}

// 坐席列表
export function aiOutboundTransfer(params) {
  return request({
    url: '/health-message/tccc/seat/ai-outbound-transfer',
    method: 'get',
    params
  })
}

export function getDoctorPatients(params) {
  return request({
    url: '/health-doctor-assistant/chat-summary/fill-preview/dynamic',
    method: 'get',
    params
  })
}
export function getGroupByUcUserIds(data) {
  return request({
    url: '/health-im/im/group/get-group-by-ucUserIds',
    method: 'POST',
    data
  })
}
